<mat-menu #menu="matMenu">
  <button [attr.guide]="'crmdealskanban-btn-1' + '__' + sanitizedUrl" *ngIf="crmType!=2" mat-menu-item
    (click)="addLeadActivity('Follow Up',0,null)">Follow Up
  </button>
  <button [attr.guide]="'crmdealskanban-btn-2' + '__' + sanitizedUrl" mat-menu-item
    (click)="addLeadActivity('Phone Call',0,null)">Phone Call</button>
</mat-menu>
<div class="root" *ngIf="kanbanviewType == 1 || kanbanviewType == 3 ">
  <div class="board">
    <div class="board-wrapper">
      <div class="board-columns">

        <div cdkDropList cdkDropListOrientation="horizontal" class="board-columns"
          (cdkDropListDropped)="dropGrid($event)">
          <div cdkDragLockAxis="x" class="board-column" *ngFor="let column of leadStatusList; let colIndex = index"
            cdkDrag>
            <div
              [ngStyle]="{'background-color': column.statusColor ? column.statusColor : 'var(--leftbackground-color)', 'color': column.statusColor ? 'white' : 'var(--leftprimary-color)'}"
              class="column-title" cdkDragHandle>
              {{ column.statusName }}
              <span class="task-count">{{ column.total }}</span>
            </div>

            <div class="tasks-container" id="{{column.statusId}}" [cdkDropListConnectedTo]="connectedList" cdkDropList
              [cdkDropListData]="column.tasks" (cdkDropListDropped)="drop($event)"
              (scroll)="onColumnScroll($event, column, colIndex)">
              <div class="task" *ngFor="let item of column.tasks; let i = index" cdkDrag>
                <div class="task-header">
                  <span class="status-label">{{item.sourceName}}</span>
                  <mat-icon class="task-icon" [matMenuTriggerFor]="menu" (click)="add_Lead(item)">more_vert</mat-icon>
                </div>
                <div class="task-body">
                  <p class="task-name"><mat-icon>perm_identity</mat-icon> {{ item.name }}</p>
                  <p class="task-phone"><mat-icon [icIcon]="icPhone" size="17px"
                      (click)="phoneNumbercall(item)"></mat-icon> {{ item.phoneNumber }}</p>
                  <p class="task-email"><mat-icon> mail_outline</mat-icon> {{ item.ownerEmail }}</p>
                  <p class="task-detail" style="margin-left: 24px;  font-size: 12px;"><b>CD:</b> &#160;{{
                    item.createdDate | date:'dd-MM-yyyy HH:mm' }}</p>
                </div>
                <div class="task-footer">
                  <mat-icon class="task-icon whatspp" [icIcon]="icWhatsapp" style="margin-top: -4px;" size="17px"
                    (click)="phonewhatsapp(item)"></mat-icon>
                  <mat-icon class="task-icon eye"
                    (click)="details(item.entityId,item.attributeSetId)">remove_red_eye</mat-icon>
                  <mat-icon class="task-icon edit"
                    (click)="editProduct(item.entityId,item.attributeSetId)">edit</mat-icon>
                  <mat-icon class="task-icon" (click)="refersh(column, colIndex)"
                    [ngStyle]="{'color':'var(--leftbackground-color)'}">refresh</mat-icon>
                  <mat-icon class="task-icon delete" [class.disabled]="!resourcePrivilege?.delete" [disabled]="!resourcePrivilege?.delete"
                    (click)="resourcePrivilege?.delete ? deleteLeadById(item.entityId) : null">delete</mat-icon>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="root" *ngIf="kanbanviewType == 2 ">
  <div class="board">
    <div class="board-wrapper">
      <div class="board-columns">

        <div cdkDropList cdkDropListOrientation="horizontal" class="board-columns"
          (cdkDropListDropped)="dropGrid($event)">
          <div cdkDragLockAxis="x" class="board-column" *ngFor="let column of leadStatusList; let colIndex = index"
            cdkDrag>
            <div [ngStyle]="{
      'background-color': column.backgroundColorAdjusted,
      'border-top': column.borderColorAdjusted,
      'color': defaultTextcolor
    }" class="column-title" cdkDragHandle>
              <div class="status-header">
                {{ column.statusName }}
                <div class="contact-count">Leads {{ column.tasks.length }}</div>
              </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="center center" class="add-contact-container" (click)="addContact()">
              <button [attr.guide]="'crmdealskanban-btn-3' + '__' + sanitizedUrl" mat-button class="add-button"
                disableRipple>
                <mat-icon class="add-icon">add</mat-icon>
                <span class="add-text">{{ getButtonText() }}</span>
              </button>
            </div>

            <div class="tasks-container" id="{{column.statusId}}" [cdkDropListConnectedTo]="connectedList" cdkDropList
              [cdkDropListData]="column.tasks" (cdkDropListDropped)="drop($event)"
              (scroll)="onColumnScroll($event, column, colIndex)">
              <div class="task" *ngFor="let item of column.tasks; let i = index" cdkDrag>
                <div class="task-header">
                  <span class="status-label">{{item.sourceName}}</span>
                  <mat-icon class="task-icon" [matMenuTriggerFor]="menu" (click)="add_Lead(item)">more_vert</mat-icon>
                </div>
                <div class="task-body">
                  <p class="task-name"><mat-icon>perm_identity</mat-icon> {{ item.name }}</p>
                  <p class="task-phone"><mat-icon [icIcon]="icPhone" size="17px"
                      (click)="phoneNumbercall(item)"></mat-icon> {{ item.phoneNumber }}</p>
                  <p class="task-email"><mat-icon> mail_outline</mat-icon> {{ item.ownerEmail }}</p>
                  <p class="task-detail" style="margin-left: 24px;  font-size: 12px;"><b>CD:</b> &#160;{{
                    item.createdDate | date:'dd-MM-yyyy HH:mm' }}</p>
                </div>
                <div class="task-footer">
                  <mat-icon class="task-icon whatspp" [icIcon]="icWhatsapp" style="margin-top: -4px;" size="17px"
                    (click)="phonewhatsapp(item)"></mat-icon>
                  <mat-icon class="task-icon eye"
                    (click)="details(item.entityId,item.attributeSetId)">remove_red_eye</mat-icon>
                  <mat-icon class="task-icon edit"
                    (click)="editProduct(item.entityId,item.attributeSetId)">edit</mat-icon>
                  <mat-icon class="task-icon" (click)="refersh(column, colIndex)"
                    [ngStyle]="{'color':'var(--leftbackground-color)'}">refresh</mat-icon>
                  <mat-icon class="task-icon delete" [class.disabled]="!resourcePrivilege?.delete" [disabled]="!resourcePrivilege?.delete"
                    (click)="resourcePrivilege?.delete ? deleteLeadById(item.entityId) : null">delete</mat-icon>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>